import {CanActivateFn, Router} from '@angular/router';
import {inject} from "@angular/core";
import {AuthService} from "../../services/auth.service";
import {from, map} from "rxjs";

export const AuthGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  return from(authService.getAccesstokenOrRefreshtokenOrApikey('accessToken')).pipe(
    map((token) => {
      if (token) return true;

      // If we are already on login, do NOT redirect
      // Using 'login' covers both /login and /#/login
      if (state.url.includes('login')) {
        return true;
      }

      // 3. Otherwise, navigate to login.
      return router.createUrlTree(['/login']);
      /*router.navigate(['/login']).then(r => console.log('to login'));
      return false;*/
    })
  );
};
